module.exports = __webpack_public_path__ + "img/suarez_0.a53cc5e5.png";